import { BasicInput, PagedResponse } from '@elotech/components';
import { AxiosPromise } from 'axios';
import { FieldProps } from 'formik';
import React, { FC } from 'react';

import { ATSLeiAto } from '../../../type';
import { LeiAtoSearch, LeiAtoSearchProps } from './LeiAtoSearch';

type FormikLeiAtoSearchProps = Partial<LeiAtoSearchProps> & {
  name: string;
  fast?: boolean;
  onSearch: (search: string) => AxiosPromise<PagedResponse<ATSLeiAto>>;
};

const FormikLeiAtoSearch: FC<FormikLeiAtoSearchProps> = ({
  name,
  fast = true,
  onSelect,
  label,
  size = 4,
  ...props
}) => {
  return (
    <BasicInput
      noLabel
      size={size}
      name={name}
      render={({ field: { onChange, ...fieldProps }, form }: FieldProps) => {
        return (
          <LeiAtoSearch
            {...props}
            {...fieldProps}
            label={label}
            onSelect={(name, value) => {
              if (onSelect) {
                onSelect(name, value);
              } else {
                form.setFieldValue(name, value);
                form.setFieldTouched(name, true);
              }
            }}
          />
        );
      }}
    />
  );
};

export { FormikLeiAtoSearch };
